var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{attrs:{"for":"uploadFile"},on:{"click":_vm.clickFile}},[_c('i',{staticClass:"el-icon-document"}),_c('input',{ref:"imgDom",staticClass:"hide",attrs:{"type":"file"},on:{"change":_vm.fileChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }